import { RootState } from '../reducers'
import { CartographyZoneResult } from '../../api/CartographyZoneApi.ts/type'

export const cartographyZonesByIdSelector = (state: RootState, zoneId: string): CartographyZoneResult | null => state.cartographyZones[zoneId]
